import React, { Component } from 'react'
import { AddToTrolley, Button as NormalButton } from '@sainsburys-tech/bolt'
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider'
import StickyBar from '../StickyBar/StickyBar'
import StickyNav from './StickyNav'
import ProductCareModalContainer from '../ProductCareModal/ProductCareModalContainer'
import FableAddToTrolleyButton from '../FableAddToTrolleyButton/FableAddToTrolleyButton'
import AddToTrolleyButtonWrapper from '../AddToTrolleyButtonWrapper/AddToTrolleyButtonWrapper'

import * as Styled from './AddToTrolleySticky.styles'

const { Button, Quantity } = AddToTrolley

class AddToTrolleySticky extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productCareModalOpen: false
    }
  }

  triggerProductCareModal = () => {
    this.setState({ productCareModalOpen: !this.state.productCareModalOpen })
  }

  closeProductCareModal = () => {
    if (this.state.productCareModalOpen) {
      this.setState({ productCareModalOpen: false })
    }
  }

  render() {
    const { productCareModalOpen } = this.state
    const {
      showAddToTrolley,
      name,
      now,
      trolleyQuantityOptions,
      trolleyButtonStickyOptions,
      trolleyButtonStickyTrackingParams,
      currentlyInViewport,
      offers,
      isEnabled,
      productId,
      warrantyItem,
      categories = [],
      quantityProps,
      inView,
      globallyOutOfStock,
      isMadeToOrder,
      quantityCount,
      'data-test': dataTest
    } = this.props

    if (!showAddToTrolley) {
      return null
    }

    const lastCategory = categories[categories.length - 1] || {}
    const synapticaId = warrantyItem && lastCategory.id ? lastCategory.id : ''

    const { partNumbers, maximumQuantity } = quantityProps
    // Unsure if the following line is needed however it may be needed incase the product service sends dodgy characters
    // Could look to remove this otherwise
    const innerHtml = { __html: name && name.replace(/\.$/, '') }
    return (
      <StickyBar inView={inView} trigger='.add-to-trolley-main button'>
        <Styled.Container data-test={`${dataTest}-container`}>
          <Styled.Header className='md-7 lg-8'>
            <Styled.Name data-test={`${dataTest}-name`} dangerouslySetInnerHTML={innerHtml} />
            <Styled.Price data-test={`${dataTest}-price`}>{now}</Styled.Price>
          </Styled.Header>
          <Styled.ATTContainer data-test={`${dataTest}-ATT-Container`} className=' sm-7 md-5 lg-4'>
            <Styled.QuantityContainer>
              <Quantity
                name='add-to-trolley-quantity-sticky-bar'
                {...trolleyQuantityOptions}
                {...{ isEnabled, maximumQuantity, partNumbers, marginBottom: 0 }}
              />
            </Styled.QuantityContainer>
            <Styled.ATTButtonContainer>
              {warrantyItem ? (
                <ProductCareButton triggerProductCareModal={this.triggerProductCareModal} />
              ) : (
                <AddToTrolleyButtonWrapper>
                  <Button data-test='sticky-bar-att' {...trolleyButtonStickyOptions} isEnabled={isEnabled} />
                  <FableAddToTrolleyButton
                    productId={trolleyButtonStickyOptions.partNumber}
                    quantity={quantityCount}
                    full
                    trackingParams={trolleyButtonStickyTrackingParams}
                    isEnabled={isEnabled}
                    data-test='sticky-bar-att'
                  />
                </AddToTrolleyButtonWrapper>
              )}
              {warrantyItem && (
                <ProductCareModalContainer
                  show={productCareModalOpen}
                  hide={this.closeProductCareModal}
                  synapticaId={synapticaId}
                />
              )}
            </Styled.ATTButtonContainer>
          </Styled.ATTContainer>
        </Styled.Container>
        <StickyNav
          {...{ currentlyInViewport, offers, productId, dataTest, globallyOutOfStock, hideNav: isMadeToOrder }}
        />
      </StickyBar>
    )
  }
}

const ProductCareButton = ({ triggerProductCareModal }) => {
  const { ITEM_CONTAINER } = useVocab()

  return (
    <NormalButton
      full
      data-test='add-to-trolley-button-product-care'
      onClick={() => {
        triggerProductCareModal()
      }}
    >
      Add to {ITEM_CONTAINER}
    </NormalButton>
  )
}

export default AddToTrolleySticky
